export const Blockchains = {
    BTC: "bitcoin",
    EOS: "eos",
    TRX: "trx",
    ETH: "eth",
    IRIS: "iris",
    COSMOS: "cosmos",
    BINANCE: "binance",
    HASHGARD: "hashgard",
    CHAINX: "chainx",
    POLKADOT: "polkadot",
    CODEX: "codex",
    FIBOS: "fibos",
    HARMONY: "harmony",
    COINEX: "coinex",
    ENIGMA: "enigma",
    KAVA: "kava",
    NERVOS: "nervos",
    NEAR: "near",
    OKCHAIN: "okchain",
    BANDCHAIN: "bandchain"
};
export const ReqeustActions = {
    REQUEST_IDENTITY: "requestIdentity",
    REQUEST_SIGNATURE: "requestSignature",
    REQUEST_ARBITRARY_SIGNATURE: "requestArbitrarySignature"
};